import { useState } from "react";
import axios from "axios";
import { ArrowRight, CheckCircle, CircleNotch } from "@phosphor-icons/react";
import { track } from "@/lib/track";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DemoForm = () => {
  const [f, setF] = useState({ name: "", email: "", company: "", role: "", message: "" });
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.email.trim()) return;
    setState("sending");
    try {
      await axios.post(`${API}/leads`, f);
      setState("done");
      track("demo_request", "/request-demo", { has_company: !!f.company.trim() });
    } catch {
      setState("error");
    }
  };
  if (state === "done") return (
    <div data-testid="demo-form-success" className="text-center py-10">
      <CheckCircle size={40} weight="fill" className="text-emerald-400 mx-auto" />
      <p className="font-heading font-bold text-xl text-white mt-4">Thank you — request received.</p>
      <p className="text-sm text-slate-400 mt-2">Our team will reach out within one business day to schedule your demonstration.</p>
    </div>
  );
  const inputCls = "w-full bg-white/5 border border-white/15 text-white text-sm px-3.5 py-3 placeholder:text-slate-500 focus:outline-none focus:border-emerald-500";
  return (
    <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <input data-testid="lead-name-input" className={inputCls} placeholder="Full name *" value={f.name} onChange={set("name")} required />
      <input data-testid="lead-email-input" className={inputCls} type="email" placeholder="Work email *" value={f.email} onChange={set("email")} required />
      <input data-testid="lead-company-input" className={inputCls} placeholder="Company" value={f.company} onChange={set("company")} />
      <input data-testid="lead-role-input" className={inputCls} placeholder="Role (e.g. Market Access Director)" value={f.role} onChange={set("role")} />
      <textarea data-testid="lead-message-input" className={`${inputCls} md:col-span-2 min-h-[100px]`} placeholder="What would you like to see? (products, markets, current challenges…)" value={f.message} onChange={set("message")} />
      {state === "error" && <p className="md:col-span-2 text-xs text-red-400">Something went wrong — please try again.</p>}
      <button data-testid="request-demo-submit" disabled={state === "sending"}
        className="md:col-span-2 bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold py-3.5 flex items-center justify-center gap-2 disabled:opacity-60">
        {state === "sending" ? <CircleNotch size={16} className="animate-spin" /> : <ArrowRight size={16} weight="bold" />}
        Request a Demo
      </button>
    </form>
  );
};
